import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';
import { Categoriecorpo, Formule } from 'src/app/models/param';
import { AddFormuleComponent } from '../../formuleabonnement/addformule/addformule.component';
import { CatcorpoformuleService } from '../catcorpoformule.service';

@Component({
  selector: 'fury-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponent implements OnInit {

  form: FormGroup;
  constructor(@Inject(MAT_DIALOG_DATA) public defaults: any,
    public dialogRef: MatDialogRef<AddFormuleComponent>,
    private fb: FormBuilder,
    private catcorpoformuleService: CatcorpoformuleService,
    private logger: NGXLogger) {
  }

  getItemSub: Subscription;
  itemsformule: Formule[];
  itemscategoriecorpo: Categoriecorpo[];

  scrollBarHorizontal = (window.innerWidth < 1200);
  temp = [];
  rows = [];
  columns = [];

  public catcorpo : string[] = [];

  selectedFormule : any ;

  ngOnInit() {
    this.getallcatcorpo();
    this.getallformule();
    this.form = this.fb.group({
      formuleid: ['', Validators.compose([Validators.required])],
      categoriecorpoid: ['', Validators.compose([Validators.required])]
      //userpisteaudit: ['', Validators.compose([Validators.required])],
    });
  }

  submit() {
    let request : any = this.form.value ;
    request.categoriecorpoid=this.catcorpo ;
    this.logger.trace(request);
    this.dialogRef.close(request);
  }


  onChangeCatcorpo(event) {
    let result : any = event ;
    if(result.source.selected) {
      this.catcorpo.push(event.source.value.categoriecorpoid);
    } else {
      this.catcorpo = this.catcorpo.filter(item => item != event.source.value.categoriecorpoid);
    }
    this.form.controls['categoriecorpoid'].setValue(this.catcorpo);
  }

  onChangeFormule(event) {
    this.form.controls['formuleid'].setValue(event.source.value);
    this.logger.warn( this.form);

   
  }


  getallcatcorpo() {
    this.getItemSub = this.catcorpoformuleService.getAll('categoriecorporate/getallcategoriecorpo')
      .subscribe(data => {

        let statuscode = data.status;
        this.logger.trace('DATA', data);

        switch (statuscode) {

          case 200: {
            this.itemscategoriecorpo = data.body;
            break;
          }

          case 204: {
            break;
          }

          default: {

            break;
          }

        }
      },
        error => {
          this.logger.error("error");
          this.logger.error(error);

          switch (error.status) {

            default: {
         //     this.snack.open('Une erreur est survenue!', 'OK', { duration: 4000 })

              break;
            }
          }
        });
  }

  getallformule() {
    this.getItemSub = this.catcorpoformuleService.getAll('formule')
      .subscribe(data => {

        let statuscode = data.status;
        this.logger.trace('DATA', data);

        switch (statuscode) {

          case 200: {
            this.itemsformule = data.body;
            break;
          }

          case 204: {
            break;
          }

          default: {

            break;
          }

        }
      },
        error => {
          this.logger.error("error");
          this.logger.error(error);

          switch (error.status) {

            default: {
         //     this.snack.open('Une erreur est survenue!', 'OK', { duration: 4000 })

              break;
            }
          }
        });
  }


}
